<mat-checkbox color="primary" [checked]="checked" [indeterminate]="indeterminate" (change)="valueChanged($event)"></mat-checkbox>
